<template>
  <div class="reminder-ribbon">
    <div class="reminder-ribbon-label">
      <span style="font-size: 10px !important;">CUSTOMER LOCAL TIME</span>
      <p class="text-center" style="font-size: 16px !important;height: 20px">{{ customerLocalTime }}</p>
    </div>
  </div>
</template>

<script>
import { Tool, DataType } from '@/util/index'
import { SystemApi } from '@/api/pandaria'
const tool = new Tool()

export default {
  name: 'customer-local-time',
  data () {
    return {
      customerLocalTime: '--:--:--',
      offsetHour: ''
    }
  },
  destroyed () {
    this.$eventBus.$off('setPersonalData')
  },
  async mounted () {
    const $this = this
    const timer = setInterval(function () {
      if (tool.isNotEmpty($this.offsetHour)) {
        const currentTime = new Date().getTime()
        const localTime = currentTime + $this.offsetHour * 3600 * 1000
        $this.customerLocalTime = tool.formatTimeString(localTime)
        $this.$forceUpdate()
      }
    }, 1000)
    $this.$once('hook:beforeDestroy', () => {
      clearInterval(timer)
    })
    $this.$eventBus.$on('setPersonalData', target => {
      $this.getTimezoneOffset(target)
    })
  },
  methods: {
    async getTimezoneOffset (personalData) {
      const $this = this
      const phoneNumbers = [personalData.cellPhone, personalData.homePhone]
      const data = {
        timeZoneType: DataType.TimeZoneTypeEnum.CUSTOMER_SIDE.value,
        condition: {
          state: personalData.state,
          phoneNumbers: phoneNumbers
        }
      }
      await SystemApi.getTimezoneOffset(data, function (result) {
        if (tool.isNotEmpty(result)) {
          $this.offsetHour = result
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reminder-ribbon {
  border-top-right-radius: 6px;
  display: block;
  position: relative;
  float: right;
  background-color: #03a9f4;
  color: white;
  opacity: 0.88;
  top: -6px;
  margin-right: 10px;
  .reminder-ribbon-label {
    right: 0;
    p {
      margin: 0;
    }
    span {
      position: relative;
      display: inline-block;
      text-align: center;
      background: #03a9f4;
      font-size: inherit;
      line-height: 1;
      padding: 8px 8px 0px;
      border-top-right-radius: 8px;
      width: 170px;
    }
    span:before {
      background: #03a9f4;
      height: 6px;
      width: 6px;
      left: -6px;
      top: 0;
    }
    span:after {
      background: #005da0;
      height: 6px;
      width: 8px;
      border-radius: 8px 8px 0 0;
      left: -8px;
      top: 0;
    }
    span:before, span:after {
      position: absolute;
      content: '';
      display: block;
    }
  }
  .reminder-ribbon-label:after {
    position: absolute;
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-left: 85px solid transparent;
    border-right: 85px solid transparent;
    border-top: 10px solid #03a9f4;
  }
}
</style>
